import React, { useEffect } from 'react';
import {
  makeStyles,
  Theme,
  Card,
  CardContent,
  Typography,
} from '@material-ui/core';
import LogUtils from 'utils/logUtils';
import { ZipModel } from 'types/zipModel';

/***********************************************************************
 * 型定義
 ***********************************************************************/
export type SearchListItemProps = {
  zipModel: ZipModel;
};

/***********************************************************************
 * Style
 ***********************************************************************/
/**
 * スタイル定義
 * @name useStyles
 */
const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  card: {},
}));

/***********************************************************************
 * メイン処理
 ***********************************************************************/
/**
 * 郵便番号情報検索一覧(アイテム)画面
 * @name SearchListItemComponent
 */
const SearchListItemComponent: React.FC<SearchListItemProps> = ({
  zipModel,
}) => {
  /**
   * クラス名
   * @name className
   * @member
   */
  const className = 'SearchListItemComponent';
  /**
   * スタイル取得
   * @name classes
   * @member
   */
  const classes = useStyles();

  /**
   * 副作用フック
   * @name useEffect
   * @function
   */
  useEffect(() => {
    /**
     * 初期設定処理
     * @name init
     * @event
     */
    const init = async () => {
      const methodName = 'init';
      try {
        LogUtils.info(`${className} ${methodName} start`);
        LogUtils.info(`${className} ${methodName} end`);
      } catch (e) {
        LogUtils.info(`${className} ${methodName} Error: ${e}`);
      }
    };
    init();
  }, []);

  /***********************************************************************
   * 画面の定義
   ***********************************************************************/
  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <CardContent>
          <Typography variant="h6" component="h6">
            {`〒 ${zipModel.zip}`}
          </Typography>
          <Typography variant="body2" component="p">
            {zipModel.fullAddress}
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
};
export default SearchListItemComponent;
